import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom'
import { Image, Tabs, TabList, TabPanels, TabPanel, Tab, Fade } from '@chakra-ui/react';

import HomeLayout from '../../../components/layouts/homelayout';
import ColumbiaTabPanel from './columbiatabpanel'
import SorelTabPanel from './soreltabpanel'
import MhwTabPanel from './mhwtabpanel'
import PranaTabPanel from './pranatabpanel'
import colBanner from '../../../components/ui/ourbrands-col-banner.jpg'
import sorBanner from '../../../components/ui/ourbrands-sorel-banner.jpg'
import mhwBanner from '../../../components/ui/ourbrands-mhw-banner.jpg'
import pranaBanner from '../../../components/ui/ourbrands-prana-banner.jpg'

export default function OurBrands() {
  const tabMap = useMemo(() => new Map([
    [0, "tab-78baa3e833ecb8b09e4"],
    [1, "tab-9d37deaf387dfeb99f5"],
    [2, "tab-7f9133205962d06a60c"],
    [3, "tab-05cf9eb2b0103558eb1"]
  ]), []);

  const [searchParams, setSearchParams] = useSearchParams();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabsChange = useCallback((index) => {
    setSearchParams(tabMap.get(index), { replace: true });
    setTabIndex(index)
  }, [tabMap, setSearchParams]);

  useEffect(() => {
    if (searchParams.has(tabMap.get(0))) {
      handleTabsChange(0);
    } else if (searchParams.has(tabMap.get(1))) {
      handleTabsChange(1);
    } else if (searchParams.has(tabMap.get(2))) {
      handleTabsChange(2);
    } else if (searchParams.has(tabMap.get(3))) {
      handleTabsChange(3);
    }
  }, [tabMap, searchParams, handleTabsChange])

  return (
    <HomeLayout align="center">
      <Tabs isFitted w="full" isLazy index={tabIndex} onChange={handleTabsChange}>
        <TabPanels>
          <TabPanel p={0}>
            <Fade in={true}>
              <Image src={colBanner} paddingTop="90px" />
            </Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>
              <Image src={sorBanner} paddingTop="90px" />
            </Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>
              <Image src={mhwBanner} paddingTop="90px" />
            </Fade>
          </TabPanel>
          <TabPanel p={0}>
            <Fade in={true}>
              <Image src={pranaBanner} paddingTop="90px" />
            </Fade>
          </TabPanel>
        </TabPanels>

        <TabList>
          <Tab>Columbia</Tab>
          <Tab>SOREL</Tab>
          <Tab>Mountain Hardwear</Tab>
          <Tab>prAna</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
           <ColumbiaTabPanel />
          </TabPanel>
          <TabPanel>
            <SorelTabPanel />
          </TabPanel>
          <TabPanel>
            <MhwTabPanel />
          </TabPanel>
          <TabPanel>
            <PranaTabPanel />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </HomeLayout>
  );
}
